import { WRITE_OFF_REASONS, WRITE_OFF_REASON } from '../../../../constants/reasons';
import { codes } from 'constants/payment';

export const amountValidator = (values, totalPriceToBePaid) => {
  const amount = Number(values.amount);

  return amount !== 0 && amount <= totalPriceToBePaid;
};

export const additionalInformationValidator = (values) => {
  const reason = WRITE_OFF_REASONS.find(({ code }) => code === values.reasonCode) || {};

  if (!reason.requiresAdditional) {
    return true;
  }

  return !!values.additionalInformation;
};

export const reasonCodeValidator = (values) => !!values.reasonCode;

export const labelValidator = (values) => !!values.label;

export const getRefundPaymentReferences = ({ reference, payoutAndBalancePayments, additionalDetails }) => [
  reference,
  ...payoutAndBalancePayments
    .filter(
      ({ method, id }) =>
        method === codes.WRITE_OFF && !additionalDetails.find(({ key, itemRef }) => key === WRITE_OFF_REASON && itemRef === id)
    )
    .map(({ refId }) => refId)
];
